/**
 * Route for `scrub-workflow`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ScrubWorkflowPage } from "../features/scrub-workflow/ScrubWorkflowPage";

export const scrubWorkflowRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/scrub-workflow",
	component: ScrubWorkflowPage,
});

export default scrubWorkflowRoute;
